import {ErrorList} from "mu-widget/lib/utils/ErrorList";

export class CommonResult {
    public errors: ErrorList;
    public entity: any;
    public status: 'ok'|'error'|string = '';

    constructor(src: any) {
        this.errors = new ErrorList();
        if (src.errors ?? []) {
            this.errors.merge(src.errors);
        }
        this.entity = src.entity;
        this.status = src.status;
    }
}